import React from "react";
import { Dropdown, DropdownToggle, DropdownMenu, Modal, ModalHeader, ModalBody } from "reactstrap";
import { SelectDropdown } from "@cadmakers-ui/core";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Feedback } from "../../../Models/Feedback";
import FeedbackActionsDropdownItem from "./FeedbackActionsDropdownItem";
import { appPaths } from "../../../../Common";
import MoveFeedbackModal from "../MoveFeedbackModal";
import FeedbackHistoryContainer from "../../FeedbackHistory/FeedbackHistoryContainer";
import FeedbackForceTransitionStateModal from "../FeedbackForceTransitionState/FeedbackForceTransitionStateModal";
import { WorkflowState } from "../../../../Workflows/Models/WorkflowState";
import { DotsMenu } from "../../../../Common/Components/DotsMenu/DotsMenu";
import MenuOption from "../../../../Common/Components/DotsMenu/MenuOption";
import { FeedbackListContext } from "../FeedbackList/FeedbackListContext";

type Props = {
  feedback: Feedback;
  onStateChange?: (feedbackCode: string, newState: WorkflowState) => void;
  dotsMode?: boolean;
};

type State = {
  isDropdownOpen: boolean;
  isMoveFeedbackModalOpen: boolean;
  isHistoryModalOpen: boolean;
  isForceTransitionModalOpen: boolean;
};

class FeedbackActionsDropdown extends React.Component<Props & RouteComponentProps, State> {
  constructor(props: Props & RouteComponentProps) {
    super(props);

    this.state = {
      isDropdownOpen: false,
      isMoveFeedbackModalOpen: false,
      isHistoryModalOpen: false,
      isForceTransitionModalOpen: false
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleMoveFeedbackModal = this.toggleMoveFeedbackModal.bind(this);
    this.toggleHistoryModal = this.toggleHistoryModal.bind(this);
    this.toggleForceTransitionModal = this.toggleForceTransitionModal.bind(this);
  }

  onClickItem = (item: any) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.linkTo) {
      this.props.history.push(item.linkTo);
    }
  };

  toggleDropdown() {
    this.setState((prevState: State) => ({
      isDropdownOpen: !prevState.isDropdownOpen
    }));
  }

  toggleHistoryModal() {
    this.setState(prevState => ({
      isHistoryModalOpen: !prevState.isHistoryModalOpen
    }));
  }

  toggleMoveFeedbackModal() {
    this.setState(prevState => ({
      isMoveFeedbackModalOpen: !prevState.isMoveFeedbackModalOpen
    }));
  }

  toggleForceTransitionModal() {
    this.setState(prevState => ({
      isForceTransitionModalOpen: !prevState.isForceTransitionModalOpen
    }));
  }

  // helper function, returns true if the user can perform at least one admin action on the given feedback
  // if a new option in the dropdown is added, please update this with the associated permission
  canDoAnything(): boolean {
    if (!this.props.feedback.permissions) {
      return false;
    }

    const {
      canEdit,
      canDelete,
      canMove,
      canViewHistory,
      canForceTransition
    } = this.props.feedback.permissions;

    return canEdit || canDelete || canMove || canViewHistory || canForceTransition;
  }

  render() {
    if (!this.props.feedback.permissions) {
      return "";
    }

    if (!this.canDoAnything()) {
      return "";
    }

    const {
      canEdit,
      canDelete,
      canMove,
      canViewHistory,
      canForceTransition
    } = this.props.feedback.permissions;

    const dropdownItems = [
      ...(canEdit
        ? [
            {
              value: "edit",
              label: "Edit",
              linkTo: appPaths.feedback.editFeedback.replace(":code", this.props.feedback.code)
            }
          ]
        : []),
      ...(canDelete
        ? [
            {
              value: "delete",
              label: "Delete",
              linkTo: appPaths.feedback.deleteFeedback.replace(":code", this.props.feedback.code)
            }
          ]
        : []),
      ...(canMove
        ? [
            {
              value: "move",
              label: "Move",
              onClick: this.toggleMoveFeedbackModal
            }
          ]
        : []),
      ...(canViewHistory
        ? [
            {
              value: "history",
              label: "History",
              onClick: this.toggleHistoryModal
            }
          ]
        : []),
      ...(canForceTransition
        ? [
            {
              value: "stateOverride",
              label: "State Override",
              onClick: this.toggleForceTransitionModal
            }
          ]
        : [])
    ];

    if (dropdownItems.length === 0) {
      return null;
    }

    return (
      <>
        <div onClick={e => e.stopPropagation()}>
          {!this.props.dotsMode && (
            <SelectDropdown
              options={dropdownItems}
              value={{
                value: "fake",
                label: "Actions"
              }}
              onChange={v => this.onClickItem(v)}
              isSearchable={false}
            />
          )}
          {this.props.dotsMode && (
            <DotsMenu clickPropagationStopped>
              {dropdownItems.map(i => (
                <MenuOption
                  label={i.label}
                  onClick={() => {
                    if (i.onClick) i.onClick();
                    if (i.linkTo) this.props.history.push(i.linkTo);
                  }}
                />
              ))}
            </DotsMenu>
          )}
        </div>

        {/* <Dropdown isOpen={this.state.isDropdownOpen} toggle={this.toggleDropdown}>
          <DropdownToggle caret>Actions</DropdownToggle>
          <DropdownMenu>
            {canEdit && (
              <FeedbackActionsDropdownItem
                feedback={this.props.feedback}
                text="Edit"
                linkTo={appPaths.feedback.editFeedback.replace(":code", this.props.feedback.code)}
              />
            )}
            {canDelete && (
              <FeedbackActionsDropdownItem
                feedback={this.props.feedback}
                text="Delete"
                linkTo={appPaths.feedback.deleteFeedback.replace(":code", this.props.feedback.code)}
              />
            )}
            {canMove && (
              <FeedbackActionsDropdownItem
                feedback={this.props.feedback}
                text="Move"
                onClick={this.toggleMoveFeedbackModal}
              />
            )}
            {canViewHistory && (
              <FeedbackActionsDropdownItem
                feedback={this.props.feedback}
                text="History"
                onClick={this.toggleHistoryModal}
              />
            )}
            {canForceTransition && (
              <FeedbackActionsDropdownItem
                feedback={this.props.feedback}
                text="State Override"
                onClick={this.toggleForceTransitionModal}
              />
            )}
          </DropdownMenu>
        </Dropdown> */}

        {/* Move Feedback Modal */}
        <FeedbackListContext.Consumer>
          {context => (
            <MoveFeedbackModal
              feedback={this.props.feedback}
              isModalOpen={this.state.isMoveFeedbackModalOpen}
              toggleModalCallback={this.toggleMoveFeedbackModal}
              onSave={context.reloadOnMove}
            />
          )}
        </FeedbackListContext.Consumer>

        {/* History Modal */}
        <Modal
          isOpen={this.state.isHistoryModalOpen}
          onToggle={this.toggleHistoryModal}
          width="1000px"
          height="90%"
        >
          <ModalHeader toggle={this.toggleHistoryModal}>Activity History</ModalHeader>
          <ModalBody>
            <FeedbackHistoryContainer code={this.props.feedback.code} />
          </ModalBody>
        </Modal>

        {/* Force Transition Modal */}
        {canForceTransition && (
          <FeedbackForceTransitionStateModal
            feedback={this.props.feedback}
            isModalOpen={this.state.isForceTransitionModalOpen}
            toggleModal={this.toggleForceTransitionModal}
            onStateChange={this.props.onStateChange}
          />
        )}
      </>
    );
  }
}

export default withRouter(FeedbackActionsDropdown);
